import { cn } from "@/lib/utils";

/**
 * Statut d'un LITIGE.
 *
 * Séparé d'`ActionStatusBadge` à dessein. Un composant unique servait les deux
 * entités : repeindre le statut d'un litige repeignait du même coup celui des
 * actions correctives, alors que les deux n'ont ni les mêmes valeurs ni la même
 * lecture — une action « ouverte » est un travail en cours parfaitement normal,
 * un litige ouvert est un dossier qui attend un traitement.
 */
// Rouge et vert : un litige ouvert appelle une action, un litige clôturé n'en
// appelle plus. La distinction doit se lire sans effort au milieu d'une liste.
//
// Le libellé reste porté par le badge, et n'est pas remplacé par une pastille :
// rouge et vert ne se distinguent pas pour une deutéranopie, et l'information
// ne doit jamais reposer sur la seule couleur.
const STYLES = {
  ouverte: "bg-rose-50 text-rose-800 border-rose-200",
  cloturee: "bg-emerald-50 text-emerald-800 border-emerald-200",
};

// Accordés au masculin : le module s'appelle « Litiges ». Les libellés féminins
// venaient de « réclamation », vocabulaire abandonné dans toute l'interface.
const LIBELLES = {
  ouverte: "Ouvert",
  cloturee: "Clôturé",
};

// Pastille pleine, reprise de la couleur du texte. En tête de ligne, elle donne
// l'état avant même la lecture ; le libellé reste présent pour ceux qui ne
// distinguent pas le rouge du vert.
const PASTILLES = {
  ouverte: "bg-rose-600",
  cloturee: "bg-emerald-600",
};

export default function ComplaintStatusBadge({ status, className, testId }) {
  const style = STYLES[status] || STYLES.ouverte;
  const libelle = LIBELLES[status] || status;
  const pastille = PASTILLES[status];
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold border",
        style,
        className,
      )}
    >
      {pastille ? (
        <span
          aria-hidden="true"
          className={cn("h-1.5 w-1.5 shrink-0 rounded-full", pastille)}
        />
      ) : null}
      {libelle}
    </span>
  );
}
